<!-- Pantalla de error cuando no hay configuraciones disponibles -->
@if (noConfigsAvailable) {
  <div class="no-configs-container">
    <div class="no-configs-content">
      <div class="no-configs-icon">
        <span class="material-symbols-outlined">error</span>
      </div>
      <h2 class="no-configs-title">No hay configuraciones disponibles</h2>
      <p class="no-configs-message">
        No se encontraron configuraciones para esta fuente de datos.
        <br>
        Por favor, comuníquese con un administrador para resolver este problema.
      </p>
      <button type="button" class="efx-button-primary" (click)="backToSourceSelector()">
        <span class="material-symbols-outlined me-2">arrow_back</span>
        Volver
      </button>
    </div>
  </div>
}

<!-- Vista de fuente dinámica -->
@if (!noConfigsAvailable) {
  @for (divSubDomain of divSubDomainJO; track divSubDomain.id; let i = $index) {
    <div>
      <!-- Seccion Titulo, botones, filtro general  -->
      <!-- [showAlertSuccess]="successDIS" -->
      @if (baseUrlfuente) {
        <app-previewDataTableTitle
          [nombreFuente]="divSubDomain.tituloPagina"
          [currentView]="currentView"
          [isEditing]="isEditing"
          [isAnyRowSelected]="selected.length > 0"
          [disableDeleteButton]="selected.length > 0"
          [inDisabledEdicionMasiva]="isEdicionMasivaDisabled"

          [addPreview]="divSubDomain.addPreview"
          [deletePreview]="divSubDomain.deletePreview"
          [bulkEditPreview]="divSubDomain.bulkEditPreview"
          [addPreviewTwo]="divSubDomain.addPreviewTwo"
          [deletePreviewTwo]="divSubDomain.deletePreviewTwo"
          [bulkEditPreviewTwo]="divSubDomain.bulkEditPreviewTwo"

          [showEliminacionMasiva]="selected?.length > 0"
          [disabledSaveButton]="isInvalid()"
          [disableEditButton]="fuenteDinamicaDetail?.noEditableView"
          [primaryKeyFieldRdsVista]="primaryKeyFieldRdsVistaFD"
          [counterExternalRDS]="counterExternalRDS"
          [historyList]="fuenteDinamicaDetail?.historyList"
          [historyListModal]="fuenteDinamicaDetail?.historyListModal"
          [toggleValue]="fuenteDinamicaDetail?.toggleHistory"
          [viewSoftDeleted]="viewSoftDeleted"
          [showRds]="isRds"
          [baseUrlfuente]="baseUrlfuente"
          [showAddObservation]="showAddObservation"
          [periods]="fuentesManuales.periods"
          [subTitle]="subTitle"
          [disabledAddButton]="disabledAddButton"
          [disabledEditButtonManual]="disabledEditButton"

          [isMultiplePreview]="multiplePreview"
          [hasMultipleConfigs]="availableConfigs && availableConfigs.length > 1"
          [selectedConfigName]="selectedConfig"

          (onToggleHistorial)="fuenteDinamicaDetail?.callHistory($event)"
          (onTimestampSelected)="fuenteDinamicaDetail?.updateFuenteHistorySelected($event)"
          (onFiltroTabla)="filterEvent = $event"
          (onVerFuentesButton)="goToFuentesPage()"
          (onEditButton)="fuenteDinamicaDetail?.onEdit()"
          (onCancelButton)="fuenteDinamicaDetail?.onCancel()"
          (onSaveButton)="fuenteDinamicaDetail?.onSubmit()"
          (onToBackButton)="handleBackButton()"
          (onDeleteButton)="deleteFuenteDinamica(divSubDomain.id)"
          (onNewObservation)="onActivate({},divSubDomain.id, true)"
          (onAddButton)="onActivate({}, divSubDomain.id, true)"
          (onViewSoftDeleted)="onViewSoftDeletedChange($event)"
          (onDataPrimarykeyRds)="onDataPrimarykeyRdsChange($event)"
          (onEdicionMasiva)="onEdicionMasiva()"
          (onSearchRdsData)="getRdsDataByCollection()"
          (onChangeConfig)="openConfigModal()"

          [showEliminacionMasiva]="showEliminacionMasivaSicomMicro && selected?.length > 0"

          (onSaveEliminacionSuplantacionIdentidad)="saveEliminacionSuplantacionIdentidad()"
          (onSaveEliminacionCancelacionPagoCarteraVencidaAlDia)="saveEliminacionCancelacionPagoCarteraVencidaAlDia()"
          (onSaveEliminacionCancelacionPagoCarteraSoloVencida)="saveEliminacionCancelacionPagoCarteraSoloVencida()"

          (onSaveEliminacionProveedorPeriodoActualCarteraVencidaAlDia)="saveEliminacionProveedorPeriodoActualCarteraVencidaAlDia()"
          (onSaveEliminacionProveedorPeriodoActualCarteraSoloVencida)="saveEliminacionProveedorPeriodoActualCarteraSoloVencida()"
          (onSaveEliminacionProveedorPeriodoHistoricoCarteraVencidaAlDia)="saveEliminacionProveedorPeriodoHistoricoCarteraVencidaAlDia()"
          (onSaveEliminacionProveedorPeriodoHistoricoCarteraSoloVencida)="saveEliminacionProveedorPeriodoHistoricoCarteraSoloVencida()"
          (onSaveEliminacionProveedorPeriodoFechaDesdeCarteraVencidaAlDia)="saveEliminacionProveedorPeriodoFechaDesdeCarteraVencidaAlDia()"
          (onSaveEliminacionProveedorPeriodoFechaDesdeCarteraSoloVencida)="saveEliminacionProveedorPeriodoFechaDesdeCarteraSoloVencida()"
          (onSaveFunction)="handleFunction($event)"
        ></app-previewDataTableTitle>
      }

      <div>
        @switch (currentView) {
          @case ('preview1') {
            <div class="container-fluid preview-container p-0 m-0">
              <app-previewDataTableFuente
                #listTable
                [source]="divSubDomain.id"
                [columnsNameDataTable]="divSubDomain.columnsName"
                [dataTablaFuente]="divSubDomain.dataVistaPreviaFilter"
                [textFilterTitle]="filterEvent"
                [viewSoftDeleted]="viewSoftDeleted"
                (onColumSelect)="onActivate($event, divSubDomain.id, false)"
                (onCheckBoxSelect)="selected = $event"
              >
              </app-previewDataTableFuente>
            </div>
          }
          @case ('preview2') {
            <div class="container-fluid preview-container p-0 m-0">
              <app-previewDataTableFuente
                #listTable2
                [source]="divSubDomain.id"
                [columnsNameDataTable]="columnsNameData2"
                [orderField]="'columnOrderTwo'"
                [dataTablaFuente]="dataVistaPreviaFilter2"
                [textFilterTitle]="filterEvent"
                [viewSoftDeleted]="viewSoftDeleted"
                [isTelco]="isTelco"
                [ultAporteFhTelco]="ultAporteFhTelco"
                (onColumSelect)="onActivate($event, divSubDomain.id, false)"
                (onCheckBoxSelect)="selected = $event"
              >
              </app-previewDataTableFuente>
            </div>
          }
          @case ('detail') {
            <app-fuente-dinamica-detail
              [editionMode]="editionMode"
              [selectedFuenteDinamica]="fuenteDinamicaSelected"
              [FUENTE_PASCAL_CASE]="divSubDomain.pascalCase"
              [SUB_DOMAIN_JO]="divSubDomain.id"
              [buttonAdd]="buttonAddTemplate"
              [isAdding]="addingObservatoin"
              (emitIsEditing)="isEditing = $event"
              (showList)="onReturnToList($event)"
              (showReloadList)="onReturnReloadList($event)"
              (onIsAdding)="addingObservatoin = $event"
              (disabledButton)="statusButton($event)"
              (setSubTitle)="setSubtitle($event)"
              [dataviewsSchema]="avroSchema"
            >
            </app-fuente-dinamica-detail>
          }
        }
      </div>
    </div>
  }
}

<ng-template #deleteComplete let-modal>
  <div class="alert alert-success alert-dismissible">
    <button type="button" class="close">&times;</button>
    <strong>¡Los registros seleccionados se eliminaron correctamente!</strong>
  </div>
</ng-template>

@if (!!structField) {
  <app-modal-eliminacion-masiva
    [inShowModal]="showEliminacionMasiva"
    [inStructSubDomain]="structField"
    [dataSeleccionados]="selected"
    (onCloseModal)="showEliminacionMasiva = false"
    (onGuardar)="handleMassUpdateRequest($event)"
  >
  </app-modal-eliminacion-masiva>
}

<!-- Modal de selección de configuraciones -->
<app-modal-config-selection
  [showModal]="showConfigModal"
  [availableConfigs]="availableConfigs"
  [fuenteName]="subDomainJO"
  [loading]="loadingConfigs"
  (modalClose)="closeConfigModal()"
  (configSelected)="onModalConfigSelected($event)"
></app-modal-config-selection>


<app-modal-functions
  [functions]="function"
  [struct]="structField"
  [data]="selected"
  [openModal]="showFunctionModal"
  [title]="functionModalTitle"
  [showComentarioAudit]="true"
  (openModalChange)="showFunctionModal = $event"
  (onSave)="handleSaveFunctionFromModal($event)"
>
</app-modal-functions>
